"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Curve;
(function (Curve) {
    Curve["EaseInBack"] = "easeInBack";
    Curve["EaseInCirc"] = "easeInCirc";
    Curve["EaseInCubic"] = "easeInCubic";
    Curve["EaseInExpo"] = "easeInExpo";
    Curve["EaseInQuad"] = "easeInQuad";
    Curve["EaseInQuart"] = "easeInQuart";
    Curve["EaseInBounce"] = "easeInBounce";
    Curve["EaseInElastic"] = "easeInElastic";
    Curve["EaseInQuint"] = "easeInQuint";
    Curve["EaseInSine"] = "easeInSine";
    Curve["EaseOutBack"] = "easeOutBack";
    Curve["EaseOutCirc"] = "easeOutCirc";
    Curve["EaseOutCubic"] = "easeOutCubic";
    Curve["EaseOutExpo"] = "easeOutExpo";
    Curve["EaseOutQuad"] = "easeOutQuad";
    Curve["EaseOutQuart"] = "easeOutQuart";
    Curve["EaseOutBounce"] = "easeOutBounce";
    Curve["EaseOutElastic"] = "easeOutElastic";
    Curve["EaseOutQuint"] = "easeOutQuint";
    Curve["EaseOutSine"] = "easeOutSine";
    Curve["EaseInOutBack"] = "easeInOutBack";
    Curve["EaseInOutCirc"] = "easeInOutCirc";
    Curve["EaseInOutCubic"] = "easeInOutCubic";
    Curve["EaseInOutExpo"] = "easeInOutExpo";
    Curve["EaseInOutQuad"] = "easeInOutQuad";
    Curve["EaseInOutQuart"] = "easeInOutQuart";
    Curve["EaseInOutBounce"] = "easeInOutBounce";
    Curve["EaseInOutElastic"] = "easeInOutElastic";
    Curve["EaseInOutQuint"] = "easeInOutQuint";
    Curve["EaseInOutSine"] = "easeInOutSine";
    Curve["Linear"] = "linear";
})(Curve = exports.Curve || (exports.Curve = {}));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/api/index.js
// module id = 58
// module chunks = 35783957827783 127651196306611 162898551421021